export const truncateText = (text: string, maxLength: number = 50): string => {
  if (!text || text.length <= maxLength) {
    return text;
  }
  return text.substring(0, maxLength) + '...';
};

export const needsTruncation = (text: string, maxLength: number = 50): boolean => {
  return Boolean(text && text.length > maxLength);
};
